import { z } from "zod";

const responseOptionSchema = z.object({
  label: z.string().min(1, "Label is required").max(50),
  value: z.string().min(1, "Value is required").max(50).regex(/^[a-z][a-z0-9_]*$/, "Value must be lowercase snake_case"),
  color: z.string().max(20).optional(),
});

export const sendMessageSchema = z
  .object({
    context_type: z.enum(["team", "player", "event", "match", "age_group", "school", "sport", "direct"]),
    context_id: z.string().min(1, "Context ID is required"),
    groups: z
      .array(z.enum(["parents", "coaches", "players"]))
      .min(1, "Select at least one recipient group"),
    // 163 -- optional category (defaults derived from context) + sub-group target.
    category: z.enum(["event_info", "team", "general"]).optional(),
    subgroup: z.enum(["forwards", "backs"]).optional().nullable(),
    content: z.string().min(1, "Message is required").max(1000),
    response_options: z.array(responseOptionSchema).min(1).max(10).optional(),
    document_id: z.string().optional(),
  })
  // 163 -- sub-group targeting (forwards/backs) only makes sense for a team.
  .refine((d) => !d.subgroup || d.context_type === "team", {
    message: "Sub-group targeting is only valid for team messages",
    path: ["subgroup"],
  });

export const sendDirectMessageSchema = z.object({
  recipient_ids: z.array(z.string().min(1)).min(1, "Select at least one recipient"),
  content: z.string().min(1, "Message is required").max(1000),
  response_options: z.array(responseOptionSchema).min(1).max(10).optional(),
  document_id: z.string().optional(),
  school_id: z.string().min(1, "School ID is required"),
});

export const respondToMessageSchema = z.object({
  value: z.string().min(1, "Response value is required").max(50),
});

export { responseOptionSchema };
